var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shape",style:('mixBlendMode: ' + _vm.mixBlendMode),attrs:{"data-id":_vm.element.id}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }